import React from "react";
import styled from "styled-components";
import logo from "../../assets/images/footer_logo.gif";
import kakao from "../../assets/images/i_kakao.png";
import insta from "../../assets/images/i_insta.png";
import youtube from "../../assets/images/i_youtube.png";
import naver from "../../assets/images/i_naver.png";
import {useNavigate} from "react-router-dom";
import {device} from "../../assets/styles/media.js";
import {useMediaQuery} from "react-responsive";

const Wrap = styled.footer`
    box-sizing: border-box;
    width: 100%;
    max-width: 100vw;
    padding: 50px 60px 60px 60px;
    background: #362579;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    
    ${device.tablet} {
        padding: 50px 30px;
    }
    ${device.mobile} {
        display: block;
        position: relative;
        padding: 100px 0 100px;
    }
`;
const FooterTop = styled.div`
    display: flex;
    align-items: center;
    text-align: center;
    max-width: 1440px;
    width: 100%;
    justify-content: space-between;
    border-bottom: 1px solid rgba(238, 238, 238, 0.5);
    margin-bottom: 20px;

    ${device.tablet} {
        align-items: center;
        padding-bottom: 10px;
        max-width: 100vw;
        width: 100%;
    }

    ${device.mobile} {
        align-items: center;
        padding-bottom: 10px;
        max-width: 100vw;
        width: 100%;
        border-bottom:none;
    }
`;

const FooterInner = styled.div`
    display: flex;
    justify-content: space-between;
    max-width: 1440px;
    width: 100%;

    ${device.tablet} {
        max-width: 100vw;
        display: flex;
        justify-content: space-between;
        box-sizing: border-box;
    }

    ${device.mobile} {
        max-width: 100vw;
        display: block;
        padding: 30px 0 30px 20px;
        margin: 0 auto;
        box-sizing: border-box;
    }
`;

const Logo = styled.div`
    padding-top: 5px;
    
    ${device.mobile} {
        position: absolute;
        top: 30px;
        left: 15px;
        zoom: 1.2;
    }
`;
const LogoImg = styled.img`
    width: 114px;
    height: 50px;
    ${device.mobile} {
        width: 85px;
        height: auto;
    }
`;
const FootInfo = styled.div`
    color: rgba(238, 238, 238, 0.7);

    ${device.tablet} {
        margin-left: 30px;
    }

    ${device.mobile} {
        display: grid;
        margin-left: 0;
        grid-template-columns: 2fr auto;
    }

`;
const Address = styled.address`
    font-style: inherit;

    ${device.tablet} {
        div:first-child {
            & dl:nth-child(3) {
                display: inline-block;

                &:after {
                    content: "";
                    width: 1px;
                    height: 11px;
                    background: rgba(255, 255, 255, 0.5);
                    display: inline-block;
                    margin: 2px 10px 0 10px;
                }
            }

            & dl:nth-child(4) {
                display: inline-block;
            }
        }

        div:nth-child(2) {
            line-height: 20px;
        }
    }
    ${device.mobile} {
     
        div:first-child {
            display: block;

            & dl:nth-child(3) {
                display: inline-block;

                &:after {
                    content: "";
                    width: 1px;
                    height: 11px;
                    background: rgba(255, 255, 255, 0.5);
                    display: inline-block;
                    margin: 2px 10px 0 10px;
                }
            }

            & dl:nth-child(4) {
                display: inline-block;
            }
        }

        div:nth-child(2) {
            & dl:nth-child(2) {
                display: inline-block;
            }
            & dl:last-child {
                display: block;
            }
         
            line-height: 20px;
        }

        dl:nth-child(1){
    
         
        }
    }

`;
const InfoBox = styled.div`
    display: flex;

    ${device.pc} {
        &:nth-child(2) {
            display: grid;
            grid-template-columns: 178px 270px 250px;

            dl:nth-child(4):before {
                display: none;
            }
        }

        &:first-child {
            dl:nth-child(3):before {
                display: none;
            }
        }
    }

    ${device.tablet} {
        display: grid;
        grid-template-columns: 220px auto;

        &:nth-child(5) {
            display: flex;
            flex-direction: row;
        }
    }

    ${device.mobile} {
        max-width: 100vw;
        width: 100%;
        display: flex;
        &:first-child {
            dl:last-child:before {
                display: none;
            }
        }

        &:nth-child(5) {
            display: flex;
            flex-direction: row;
        }
        
        &:nth-child(4){
           display: block;
            dl:last-child:before {
                display: none;
            }
        }
    }
`;
const InfoCont = styled.dl`
    display: flex;
    align-items: center;
    margin-top: 5px;

    &:not(:first-child):before {
        content: "";
        display: inline-block;
        width: 1px;
        height: 10px;
        margin: 2px 10px 0;
        background: #fff;
        opacity: 0.4;
    }
    

    ${device.tablet} {
        display: inline;
    }

    ${device.mobile} {
        display: block;
        line-height: 14px;
    }

`;
const Dt = styled.dt`
    font-size: 13px;
    font-weight: 300;
    line-height: 18px;
    
    ${device.tablet} {
         display: inline;
         font-size: 14px;
         font-weight: 500;
         letter-spacing: 1px;
         }

    ${device.mobile} {
        display: inline;
        font-size: 13px;
        font-weight: 500;
        letter-spacing: -0.5px;
    }
`;
const Dd = styled.dd`
    font-size: 13px;
    font-weight: 300;
    line-height: 18px;
    padding-left: 3px;
    
     ${device.tablet} {
         display: inline;
         padding-left: 0;
         margin-left: 5px;
         font-size: 14px;
         font-weight: 500;
     }
    ${device.mobile} {
        display: inline;
        padding-left: 0;
        margin-left: 0;
        margin-right: 0;
        font-size: 13px;
        line-height: 14px;
        font-weight: 400;
        letter-spacing: -0.5px;
    }
`;
const Copyright = styled.p`
    display: block;
    padding-top: 15px;
    font-size: 13px;
    opacity: 0.6;
`;

const PolicyList = styled.ul`
    display: flex;
    height: 20px;
    ${device.mobile} {
        position: absolute;
        width: 80%;
        top: 120px;
        left: 20px;
        display: flex;
        margin-bottom: 4px;
        padding-bottom: 7px;
        border-bottom: 1px solid rgba(255, 255, 255, 0.5);
    }
`;

const PolicyListItem = styled.li`
    display: flex;
    font-weight: 400;
    cursor: pointer;
    color: rgba(238, 238, 238, 0.7);
    font-size: 14px;

    &:first-child:after {
        content: "";
        width: 1px;
        height: 11px;
        background: rgba(238, 238, 238, 0.7);
        display: inline-block;
        margin: 2px 10px 0 10px;

        ${device.tablet} {
            height: 15px;
            margin: 3px 10px 0 10px;
            background: rgba(255, 255, 255, 0.5);
        }
        ${device.mobile} {
            height: 15px;
            margin: 3px 10px 0 10px;
            background: rgba(255, 255, 255, 0.5);
        }
    }

    &:last-child {
       font-weight: 800;
    }

    ${device.tablet} {
        font-weight: bold;
        font-size: 1.1rem;
    }
    ${device.mobile} {
        font-weight: bold;
        font-size: 14px;
    }

`;

const SnsList = styled.div`
    display: flex;
    
    ${device.pc} {
        grid-row-start: 1;
        grid-column-start: 2;
        margin-left: 0 !important;
    }
    ${device.tablet}{
        zoom: 1.2;
    }
    ${device.mobile}{
        position: absolute;
        bottom: 60px;
        left: 10px;
    }
`;
const Sns = styled.a``;
const SnsImg = styled.img`
    width: 40px;
    height: 40px;
`;


// 공통 리스트 렌더링
const InfoList = ({list}) => (
    list.map((item, index) => (
        <InfoCont key={index}>
            <Dt>{item.title} : </Dt>
            <Dd>{item.sub}</Dd>
        </InfoCont>
    ))
);


const Footer = () => {
    const navigate = useNavigate();
    const isTablet = useMediaQuery({maxWidth: 1023});
    const footList = [
        {title: "(주)더존비앤씨티  대표이사", sub: "윤성태"},
        {title: "주소", sub: "강원도 춘천시 남산면 충효로 437"},
        {title: "전화번호", sub: "033-913-1400"},
        {title: "팩스번호", sub: "033-913-1420"},
    ];

    const footList2 = [
        {title: "단체예약", sub: "033-913-1433"},
        {title: "제휴문의 ", sub: "033-913-1432"},
        {title: "이메일", sub: "dforest@dforest.co.kr"},
        {title: "사업자등록번호", sub: "813-81-02650"},
        {title: "통신판매신고번호 ", sub: "제2023-강원춘천-0353호"},
    ];

    const snsLinks = [
        {
            href: "https://pf.kakao.com/_xkKKlK",
            imgSrc: kakao,
            alt: "카카오톡"
        },
        {
            href: "https://www.instagram.com/d.forest_park/",
            imgSrc: insta,
            alt: "인스타그램"
        },
        {
            href: "https://map.naver.com/v5/entry/place/1806671210?c=14211267.4978170,4542262.6170587,13,0,0,0,dh&placePath=%2Fhome%3Fentry=pll",
            imgSrc: naver,
            alt: "네이버"
        },
        {
            href: "https://www.youtube.com/channel/UCKqawuweetJZ4_HnxMELyXA/featured",
            imgSrc: youtube,
            alt: "유튜브"
        }
    ];
    const policyItems = [
        { text: "이용약관", to: "/terms" },
        { text: "개인정보처리방침", to: "/policy" },
    ];
    const groupListByTwo = (list) => {
        const result = [];
        for (let i = 0; i < list.length; i += 2) {
            result.push(list.slice(i, i + 2));
        }
        return result;
    };

    const renderGroupedInfo = (list) => {
        const grouped = groupListByTwo(list);
        return grouped.map((group, idx) => (
            <InfoBox key={idx}>
                <InfoList list={group} />
            </InfoBox>
        ));
    };
    return (
            <Wrap>

                <FooterTop>
                    <PolicyList>
                        {policyItems.map(({ text, to }, idx) => (
                            <PolicyListItem key={idx} onClick={() => navigate(to)}>
                                {text}
                            </PolicyListItem>
                        ))}
                    </PolicyList>

                <SnsList>
                    {snsLinks.map(({href, imgSrc, alt}, index) => (
                        <Sns key={index} href={href} target="_blank" rel="noopener noreferrer">
                            <SnsImg src={imgSrc} alt={alt}/>
                        </Sns>
                    ))}
                </SnsList>
                </FooterTop>

                <FooterInner>
                    {/* 로고 */}
                    <Logo href="/">
                        <LogoImg src={logo} alt={"강아지숲"}/>
                    </Logo>


                <FootInfo>
                    <Address>
                        {isTablet ? (<>
                            {renderGroupedInfo(footList)}
                            {renderGroupedInfo(footList2)}
                        </>):(<>
                            <InfoBox>
                                <InfoList list={footList}/>
                            </InfoBox>
                            <InfoBox>
                                <InfoList list={footList2}/>
                            </InfoBox>
                        </>)}
                        <Copyright>Copyright &copy; 2015 DOUZONE B&CT. All rights reserved.</Copyright>
                    </Address>

                </FootInfo>
                </FooterInner>
            </Wrap>
    );
};

export default Footer;
